
<div>
  <div class="nestedInnerItem">
    <cvt-select
      :value="borderStyle"
      mode="dropdown"
      :background-mode="mode"
      :floating-label="false"
      :label="$t('elements.properties.border.style')"
      @input="(value) => onBorderStyleChange(value)"
    >
      <option
        v-for="style in borderStyles"
        :key="style"
        :value="style"
        v-text="style"
      />
    </cvt-select>
    <div style="margin: 5px" />
    <template v-if="themeManagerVersion > 1">
      <cvt-select
        :value="borderColor"
        mode="dropdown"
        :background-mode="mode"
        :floating-label="false"
        :label="$t('elements.properties.border.color')"
        @input="(value) => onBorderColorChange(value)"
      >
        <option
          v-for="(colorData, colorKey) in themeColors"
          :key="colorKey"
          :value="colorKey"
        >
          <span class="color-option">
            <span
              class="color-swatch"
              :style="{ backgroundColor: getRgbString(colorData) }"
            ></span>
            <span class="color-label">{{ colorKey }}</span>
          </span>
        </option>
      </cvt-select>
    </template>
    <template v-else>
      <cvt-input
        v-model="borderColorComputed"
        style="width: max-content"
        type="text"
        :clearable="false"
        :label="$t('elements.properties.border.color')"
      />
    </template>
  </div>

  <div class="divider mt-2" />

  <div v-if="showBorderPosition" class="row">
    <div class="col-md-12 d-flex align-items-center text-capitalize">
      {{ $t('elements.properties.border.position') }}
    </div>
  </div>

  <div v-if="showBorderPosition" class="row">
    <div class="col">
      <cvt-radio-group
        :key="borderPositionKey"
        orientation="horizontal"
        :initial-value="positionDefVal"
      >
        <cvt-radio-button
          :value="pv.all"
          :disabled="disableAllBorder"
          type="multiselect"
          @radioClick="($event) => updatePosition($event, 'all')"
        >
          <cvt-icon icon="border-all"></cvt-icon>
        </cvt-radio-button>
        <cvt-radio-button
          :value="pv.top"
          type="multiselect"
          @radioClick="($event) => updatePosition($event, 'top')"
        >
          <cvt-icon icon="border-top"></cvt-icon>
        </cvt-radio-button>
        <cvt-radio-button
          :value="pv.btm"
          type="multiselect"
          @radioClick="($event) => updatePosition($event, 'btm')"
        >
          <cvt-icon icon="border-bottom"></cvt-icon>
        </cvt-radio-button>
        <cvt-radio-button
          :value="pv.lft"
          type="multiselect"
          @radioClick="($event) => updatePosition($event, 'lft')"
        >
          <cvt-icon icon="border-left"></cvt-icon>
        </cvt-radio-button>
        <cvt-radio-button
          :value="pv.ryt"
          type="multiselect"
          @radioClick="($event) => updatePosition($event, 'ryt')"
        >
          <cvt-icon icon="border-right"></cvt-icon>
        </cvt-radio-button>
      </cvt-radio-group>
    </div>
  </div>

  <div v-if="showBorderPosition" class="divider mt-2" />

  <div class="row">
    <div class="col-md-12 mb-3 d-flex align-items-center text-capitalize">
      {{ $t('elements.properties.border.width') }}
    </div>
    <div class="col-12">
      <cvt-slider
        id="slider-border-width"
        :tooltips-enabled="true"
        :step-marks-enabled="true"
        class="slider"
        :min="minBorderWidth"
        :max="maxBorderWidth"
        :value="borderWidth"
        :step="1"
        @change="onBorderWidthChange"
      />
    </div>
  </div>

  <div v-if="showBorderRadius" class="divider mt-2" />

  <div v-if="showBorderRadius" class="row">
    <div class="col-md-12 mb-3 d-flex align-items-center text-capitalize">
      {{ $t('elements.properties.border.radius') }}
    </div>
    <div class="col-12">
      <cvt-slider
        id="slider-border-radius"
        :tooltips-enabled="true"
        :step-marks-enabled="true"
        class="slider"
        :min="minBorderRadius"
        :max="maxBorderRadius"
        :value="borderRadius"
        :step="5"
        @change="onBorderRadiusChange"
      />
    </div>
  </div>
</div>
